import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-double-right-icon',
  templateUrl: './navigation-angle-double-right.component.html'
})
export class NavigationAngleDoubleRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
